import { render, staticRenderFns } from "./CeoModerateModeration.vue?vue&type=template&id=fd95f9c0"
import script from "./CeoModerateModeration.vue?vue&type=script&lang=js"
export * from "./CeoModerateModeration.vue?vue&type=script&lang=js"
import style0 from "./CeoModerateModeration.vue?vue&type=style&index=0&id=fd95f9c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports